function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { useStateWithCallback } from 'unitx-ui/hooks';
import { mutableGraphMap } from "./useGraph";
import { useElement } from "./useElement";
const DEFAULT_BOUNDING_BOX = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};
export default (props => {
  const {
    id,
    position,
    onPositionChange,
    graphID,
    config
  } = props;
  const {
    cy,
    clustersByID
  } = mutableGraphMap[graphID];
  const [, setState] = useStateWithCallback({}, () => {});
  const contextRef = React.useRef({
    render: callback => setState({}, callback),
    boundingBox: DEFAULT_BOUNDING_BOX
  });
  const element = React.useMemo(() => cy.add({
    data: {
      id,
      context: contextRef.current
    },
    // ...(parentID ? { parent: parentID } : {}),
    position: _objectSpread({}, position),
    group: 'nodes' // eslint-disable-next-line react-hooks/exhaustive-deps

  }), [cy, id]);
  React.useEffect(() => {
    element.on('position', () => {
      element.connectedEdges().forEach(mutableEdge => {
        mutableEdge.data().onPositionChange();
      });
      onPositionChange === null || onPositionChange === void 0 ? void 0 : onPositionChange({
        element,
        context: contextRef.current
      });
    });
    return () => {
      cy.remove(element);
    };
  }, // destroy
  [cy, id]);
  useElement({
    contextRef,
    cy,
    element,
    config
  });
  return {
    element,
    context: contextRef.current,
    cluster: clustersByID[id]
  };
});